// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Label,
  CartesianGrid,
} from 'recharts';

// Enums
import { OrderedQuestionDataType } from 'engagementReport/enums/propTypes';

// Utilities
import { colors, rtlLanguage } from 'common/utils/helpers';

// Hooks
import useOrderedBarChartData from 'engagementReport/hooks/useOrderedBarChartData';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';

const OrderedHorizontalBarChart = ({ data }) => {
  const { chartData, tooltipAttributes } = useOrderedBarChartData(data);

  return (
    <>
      <ResponsiveContainer width="100%" aspect={16 / 9}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
          layout="vertical"
        >
          <CartesianGrid horizontal={false} stroke="#e8e8e8" strokeWidth={1} />
          <YAxis
            type="category"
            dataKey="label"
            tickLine={false}
            stroke="#636363"
            strokeWidth={1}
            interval={0}
            orientation={rtlLanguage() ? 'right' : 'left'}
          >
            <Label value="Priority" position="left" angle={-90} />
          </YAxis>
          <XAxis
            type="number"
            domain={[0, 100]}
            ticks={[0, 25, 50, 75, 100]}
            tickLine={false}
            unit="%"
            interval={0}
            axisLine={false}
          >
            <Label value="# Of Responses" position="bottom" />
          </XAxis>
          <Tooltip
            content={<CustomTooltip attributes={tooltipAttributes} ranked />}
            cursor={{ fill: 'rgba(100, 100, 100, 0.05)' }}
            isAnimationActive={false}
          />
          {data.options.map(({ id, label }, index) => (
            <Bar
              key={id}
              label={label}
              dataKey={`values.${id}.percentage`}
              barSize={20}
              fill={colors[index % colors.length]}
              stackId="meow"
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
      <Legend
        layout="vertical"
        width="100%"
        wrapperStyle={{ marginTop: '20px', position: 'static' }}
        payload={data.options.map(({ id, label }, index) => ({
          id,
          type: 'square',
          value: label,
          color: colors[index % colors.length],
        }))}
      />
    </>
  );
};

Legend.propTypes = {
  width: PropTypes.string.isRequired,
};

OrderedHorizontalBarChart.propTypes = {
  data: OrderedQuestionDataType.isRequired,
};

export default OrderedHorizontalBarChart;
